/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiManualAlertRationale } from './InternalApiManualAlertRationale';
import {
    InternalApiManualAlertRationaleFromJSON,
    InternalApiManualAlertRationaleFromJSONTyped,
    InternalApiManualAlertRationaleToJSON,
    InternalApiManualAlertRationaleToJSONTyped,
} from './InternalApiManualAlertRationale';

/**
 * 
 * @export
 * @interface InternalApiCreateManualAlertCommand
 */
export interface InternalApiCreateManualAlertCommand {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateManualAlertCommand
     */
    personId: string;
    /**
     * External transaction ID
     * @type {string}
     * @memberof InternalApiCreateManualAlertCommand
     */
    transactionId?: string;
    /**
     * 
     * @type {InternalApiManualAlertRationale}
     * @memberof InternalApiCreateManualAlertCommand
     */
    rationale: InternalApiManualAlertRationale;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateManualAlertCommand
     */
    rationaleComment?: string;
}



/**
 * Check if a given object implements the InternalApiCreateManualAlertCommand interface.
 */
export function instanceOfInternalApiCreateManualAlertCommand(value: object): value is InternalApiCreateManualAlertCommand {
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('rationale' in value) || value['rationale'] === undefined) return false;
    return true;
}

export function InternalApiCreateManualAlertCommandFromJSON(json: any): InternalApiCreateManualAlertCommand {
    return InternalApiCreateManualAlertCommandFromJSONTyped(json, false);
}

export function InternalApiCreateManualAlertCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateManualAlertCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'personId': json['personId'],
        'transactionId': json['transactionId'] == null ? undefined : json['transactionId'],
        'rationale': InternalApiManualAlertRationaleFromJSON(json['rationale']),
        'rationaleComment': json['rationaleComment'] == null ? undefined : json['rationaleComment'],
    };
}

export function InternalApiCreateManualAlertCommandToJSON(json: any): InternalApiCreateManualAlertCommand {
    return InternalApiCreateManualAlertCommandToJSONTyped(json, false);
}

export function InternalApiCreateManualAlertCommandToJSONTyped(value?: InternalApiCreateManualAlertCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personId': value['personId'],
        'transactionId': value['transactionId'],
        'rationale': InternalApiManualAlertRationaleToJSON(value['rationale']),
        'rationaleComment': value['rationaleComment'],
    };
}

